const readText = (value: unknown): string => String(value ?? '').trim();

export const buildFinancialAidInviteEntryUrl = ({
  academicYear,
  inviteToken,
  origin,
}: {
  academicYear?: string | null;
  inviteToken?: string | null;
  origin?: string | null;
}): string => {
  const baseOrigin = readText(origin)
    || (typeof window !== 'undefined' ? readText(window.location.origin) : '');
  const baseUrl = baseOrigin.replace(/\/+$/, '');
  const params = new URLSearchParams();
  const token = readText(inviteToken);
  const year = readText(academicYear);

  if (token) {
    params.set('invite', token);
  }
  if (year) {
    params.set('academicYear', year);
  }

  const query = params.toString();
  return `${baseUrl}/parent/portal--new/financial-aid${query ? `?${query}` : ''}`;
};
